<template>
    <div class="sl-order-form__line-side" :class="'sl-order-form__line-side-' + side">
        <!-- Helper -->
        <div class="sl-order-form__line-band-wrapper">
            <div class="sl-order-form__line-band-content"></div>
        </div>

        <!-- Error Wrapper -->
        <div class="sl-order-form__line-content-wrapper">
            <!-- Field Wrapper -->
            <div class="sl-order-form__field-wrapper">
                <!-- Field -->
                <div
                    class="sl-order-form__protoconv"
                    :class="{ 'sl-order-form__protoconv--loading': loading }"
                >
                    <div
                        class="lsn-btn"
                        :class="{
                            'lsn-btn--primary-outline': !disabled,
                            'lsn-btn--gray-outline': disabled,
                            'cursor-not-allowed': disabled,
                        }"
                        :tabindex="tabIndex"
                        @click="onClick"
                        @keypress.enter="onClick"
                        @keypress.space.prevent="onClick"
                    >
                        <span class="sl-order-form__protoconv-label">
                            <template v-if="loading">
                                <img src="/img/loader.gif" class="inline mx-14" />
                            </template>

                            <template v-else>
                                {{ parameter.form_label }} 🚀
                            </template>
                        </span>
                    </div>
                </div>
            </div>

            <!-- Error -->
            <div v-if="error" class="sl-order-form__error-wrapper">
                <div class="sl-order-form__error">
                    {{ error }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import {
    fieldProps,
    default as useFieldComposable,
} from '@/composables/FieldComposable';
import FormPrototype from '@/models/FormPrototype';
import LensOrderUrlManager from '@/views/order/lenses/LensOrderUrlManager.js';


// ------------------------------------------------------------ PROPS

const props = defineProps(fieldProps);


// ------------------------------------------------------------ EMITS

const emit = defineEmits([]);


// ------------------------------------------------------------ COMPOSABLES

const { t } = useI18n({ useScope: 'global' });
const store = useStore();
const router = useRouter();
const route = useRoute();
const {
    // Computed
    tabIndex,
} = useFieldComposable(props, emit, store);


// ------------------------------------------------------------ DATA

const loading = ref(false);


// ------------------------------------------------------------ COMPUTED

const proto = computed(() =>
{
    /** @type {FormPrototype} */
    const proto = store.getters['lensOrder/getPrototype'](props.side);
    return proto;
});

const disabled = computed(() => loading.value);


// ------------------------------------------------------------ METHODS

function onClick()
{
    if(loading.value)
        return;

    const eid = store.state.account.cEntity.id;
    const source = proto.value.code;
    const target = props.parameter.value;
    const values = proto.value.getValues(true);

    loading.value = true;
    proto.value.convert(eid, target, values)
        .then(async converted =>
        {
            const side = props.side;

            // Redirect to the target prototype form
            const um = new LensOrderUrlManager(route);
            um.setPrototypeCode(side, target);
            await router.push({ path: um.getPath() });

            // Set converted parameters
            proto.value.setValues(converted, {
                form_display:          'HIDDEN',
                form_splitted_display: 'HIDDEN',
            });

            // Re-template
            store.dispatch('lensOrder/template', { side, initValues: converted });
        })
        .catch(error =>
        {
            // todo: handle error
        })
        .finally(() =>
        {
            loading.value = false;
        });
}
</script>

<style lang="scss" scoped>
.sl-order-form__protoconv-label
{
    @apply flex justify-center items-center w-full h-full;
}
</style>
